app.config([
  "$routeProvider",
  "config",
  function ($routeProvider, config) {
    $routeProvider
      .when("/", {
        templateUrl: "template/init.html?v=" + config.appVersion,
        controller: "initCtrl",
        data: {
          meta: {
            title: "",
            description: "",
          },
        },
      })
      .when("/home", {
        templateUrl: "template/home.html?v=" + config.appVersion,
        controller: "homeCtrl",
        data: {
          meta: {
            title: "",
            description: "",
          },
        },
      })
      .when("/explore", {
        templateUrl: "template/explore.html?v=" + config.appVersion,
        controller: "exploreCtrl",
        data: {
          meta: {
            title: "",
            description: "",
          },
        },
      })
      .when("/play/:contentID", {
        templateUrl: "template/play.html?v=" + config.appVersion,
        controller: "playCtrl",
        data: {
          meta: {
            title: "",
            description: "",
          },
        },
      })
      .when("/play/:contentID/:playlistID", {
        //if accessing from a subscription
        templateUrl: "template/play.html?v=" + config.appVersion,
        controller: "playCtrl",
        data: {
          meta: {
            title: "",
            description: "",
          },
        },
      })
      .when("/item/:contentID", {
        templateUrl: "template/item.html?v=" + config.appVersion,
        controller: "itemCtrl",
        data: {
          meta: {
            title: "",
            description: "",
          },
        },
      })
      .when("/cart", {
        templateUrl: "template/cart.html?v=" + config.appVersion,
        controller: "cartCtrl",
        data: {
          meta: {
            title: "",
            description: "",
          },
        },
      })
      .when("/cart/addItem/:contentID", {
        templateUrl: "template/cartAddItem.html?v=" + config.appVersion,
        controller: "addToCartCtrl",
        data: {
          meta: {
            title: "",
            description: "",
          },
        },
      })
      .when("/purchaseNow/:contentID", {
        templateUrl: "template/cartAddItem.html?v=" + config.appVersion,
        controller: "purchaseNowCtrl",
        data: {
          meta: {
            title: "",
            description: "",
          },
        },
      })
      .when("/purchase", {
        templateUrl: "template/purchase.html?v=" + config.appVersion,
        controller: "purchaseCtrl",
        data: {
          meta: {
            title: "",
            description: "",
          },
        },
      })
      .when("/purchaseLogin", {
        templateUrl: "template/purchaseLogin.html?v=" + config.appVersion,
        controller: "registerCtrl",
        data: {
          meta: {
            title: "",
            description: "",
          },
        },
      })
      .when("/transactions", {
        templateUrl: "template/transactions.html?v=" + config.appVersion,
        controller: "transactionsCtrl",
        data: {
          meta: {
            title: "",
            description: "",
          },
        },
      })
      .when("/playlist/:playlistID", {
        templateUrl: "template/playlist.html?v=" + config.appVersion,
        controller: "playlistCtrl",
        data: {
          meta: {
            title: "",
            description: "",
          },
        },
      })
      .when("/playlist/:playlistID/:paymentID", {
        templateUrl: "template/playlist.html?v=" + config.appVersion,
        controller: "playlistCtrl",
        data: {
          meta: {
            title: "",
            description: "",
          },
        },
      })
      .when("/login", {
        // Password.js
        templateUrl: "template/login.html?v=" + config.appVersion,
        controller: "loginCtrl",
        data: {
          meta: {
            title: "",
            description: "",
          },
        },
      })
      .when("/tickets", {
        templateUrl: "template/tickets.html?v=" + config.appVersion,
        controller: "ticketsCtrl",
        data: {
          meta: {
            title: "",
            description: "",
          },
        },
      })
      .when("/competition/:contentID", {
        templateUrl: "template/competition.html?v=" + config.appVersion,
        controller: "",
        data: {
          meta: {
            title: "",
            description: "",
          },
        },
      })
      .when("/logout", {
        // Password.js
        templateUrl: "template/logout.html?v=" + config.appVersion,
        controller: "logoutCtrl",
        data: {
          meta: {
            title: "",
            description: "",
          },
        },
      })
      .when("/register", {
        templateUrl: "template/register.html?v=" + config.appVersion,
        controller: "registerCtrl",
        data: {
          meta: {
            title: "",
            description: "",
          },
        },
      })
      .when("/changePassword", {
        templateUrl: "template/changePassword.html?v=" + config.appVersion,
        controller: "changePasswordCtrl",
        data: {
          meta: {
            title: "",
            description: "",
          },
        },
      })
      .when("/forgotPassword", {
        templateUrl: "template/forgotPassword.html?v=" + config.appVersion,
        controller: "forgotPasswordCtrl",
        data: {
          meta: {
            title: "",
            description: "",
          },
        },
      })
      .when("/tokenReset/:token", {
        templateUrl: "template/resetPassword.html?v=" + config.appVersion,
        controller: "resetPasswordCtrl",
        data: {
          meta: {
            title: "",
            description: "",
          },
        },
      })
      .when("/manageAccount", {
        templateUrl: "template/manageAccount.html?v=" + config.appVersion,
        controller: "manageAccountCtrl",
        data: {
          meta: {
            title: "",
            description: "",
          },
        },
      })

      .when("/faq", {
        templateUrl: "template/faq.html?v=" + config.appVersion,
        controller: "faqCtrl", //in terms
        data: {
          meta: {
            title: "",
            description: "",
          },
        },
      })
      .when("/terms", {
        templateUrl: "template/terms.html?v=" + config.appVersion,
        controller: "termsCtrl", //in terms
        data: {
          meta: {
            title: "",
            description: "",
          },
        },
      })
      .when("/contactus", {
        templateUrl: "template/contactus.html?v=" + config.appVersion,
        controller: "contactusCtrl",
        data: {
          meta: {
            title: "",
            description: "",
          },
        },
      })
      .when("/login/item/:contentID", {
        // Password.js
        templateUrl: "template/login.html?v=" + config.appVersion,
        controller: "loginItemCtrl",
        data: {
          meta: {
            title: "",
            description: "",
          },
        },
      })
      .when("/donate", {
        templateUrl: "template/donate.html?v=" + config.appVersion,
        controller: "donationCtrl",
        data: {
          meta: {
            title: "",
            description: "",
          },
        },
      })
      .when("/tessitura/:contentId/:customerId", {
        //TSO
        templateUrl: "template/tessitura.html?v=" + config.appVersion,
        controller: "tessituraCtrl",
        data: {
          meta: {
            title: "",
            description: "",
          },
        },
      })
      .when("/tessituraprod/:contentId/:prod_season_no/:ticket_no", {
        templateUrl: "template/tessitura.html?v=" + config.appVersion,
        controller: "tessituraCtrl",
        data: {
          meta: {
            title: "",
            description: "",
          },
        },
      })
      .when("/psid/:contentId/:prod_season_no/:order_no", {
        templateUrl: "template/tessitura.html?v=" + config.appVersion,
        controller: "tessituraCtrl",
        data: {
          meta: {
            title: "",
            description: "",
          },
        },
      })
      .when("/tsoc/:contentId/:order_no/:customer_no", {
        templateUrl: "template/tessitura.html?v=" + config.appVersion,
        controller: "tessituraCtrl",
        data: {
          meta: {
            title: "",
            description: "",
          },
        },
      })
      .when("/subscribe", {
        templateUrl:
          "template/subscriptionCheckout.html?v=" + config.appVersion,
        controller: "subscriptionCheckoutCtrl",
        data: {
          meta: {
            title: "",
            description: "",
          },
        },
      })
      .when("/tsocplay/:contentId/:order_no/:customer_no/:child_contentId", {
        templateUrl: "template/tessitura.html?v=" + config.appVersion,
        controller: "tessituraCtrl",
        data: {
          meta: {
            title: "",
            description: "",
          },
        },
      })
      .when("/siteUnavailable", {
        templateUrl: "template/siteUnavailable.html?v=" + config.appVersion,
        controller: "404Ctrl",
        data: {
          meta: {
            title: "",
            description: "",
          },
        },
      })
      .when("/order/:orderId/complete", {
        templateUrl:
          "template/subscriptionOrderComplete.html?v=" + config.appVersion,
        controller: "subscriptionOrderCompleteCtrl",
        data: {
          meta: {
            title: "",
            description: "",
          },
        },
      })
      .when("/siteUnavailable", {
        templateUrl: "template/siteUnavailable.html?v=" + config.appVersion,
        controller: "404Ctrl",
        data: {
          meta: {
            title: "",
            description: "",
          },
        },
      })
      .when("/error", {
        templateUrl: "template/404.html?v=" + config.appVersion,
        controller: "404Ctrl",
        data: {
          meta: {
            title: "",
            description: "404",
          },
        },
      })
      .when("/siteError", {
        templateUrl: "template/siteError.html?v=" + config.appVersion,
        controller: "siteErrorCtrl",
        data: {
          meta: {
            title: "",
            description: "404",
          },
        },
      })
      .when("/customError", {
        templateUrl: "template/customError.html?v=" + config.appVersion,
        controller: "customErrorCtrl",
        data: {
          meta: {
            title: "",
            description: "404",
          },
        },
      })
      .otherwise({
        templateUrl: "template/customPage.html?v=" + config.appVersion,
        controller: "customPageCtrl",
        data: {
          meta: {
            title: "",
            description: "",
          },
        },
      });
  },
]);
